import React, { useEffect } from "react";
import Panel from "./components/panel";
import Introduction from "./components/introduction";
import Together from "./components/together";
import Resources from "./components/resources";
import Join from "./components/join";
import Latest from "./components/latest";
import Whouse from "./components/user";
import HotResource from "./components/HotResource";
import WOW from "wowjs";
import "animate.css/animate.min.css";
import styles from './index.module.scss';
const Home = () => {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // 避免动态添加元素时触发动画
      offset: 30,
    });
    wow.init();
    return () => {
      // 清理操作
    };
  }, []);

  // 获取类型列表和后缀列表
  useEffect(() => {
    let data = localStorage.getItem("jsonTypeData")
    if (!data) {
      fetch(`${process.env.PUBLIC_URL}/share.json`)
        .then((response) => response.json())
        .then((jsonData) => {
          localStorage.setItem("jsonTypeData", JSON.stringify(jsonData))
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, []);
  return (
    <div style={{ overflowX: "hidden" }}>
      <Panel />
      <Introduction />
      <Resources />
      <Together />
      <div className={styles.bg_wrap}>
        <Latest />
      </div>
      <Join />
      <Whouse />
      <HotResource/>
    </div>
  );
};
export default Home;
